import React from "react";
import { CppOutcomeContents } from "./Content/CppOutcomes";
import tickMark from "../../img/cpp-outcomes-tick.png";
import "./Styles/Outcome.css";

const Outcomes = () => {
    const outcomeContents = CppOutcomeContents;

    return (
        <div className="cpp-learning-outcomes-wrapper">
            <div className="cpp-learning-outcomes-content">
                <h2>{outcomeContents.sectionTitle}</h2>
                <div className="cpp-learning-outcomes-points-wrapper">
                    {outcomeContents.OutcomesList &&
                        outcomeContents.OutcomesList.map((data, index) => (
                            <React.Fragment key={index}>
                                <div className="cpp-learning-outcomes-points" key={index}>
                                    <img src={tickMark} alt="" />
                                    <h3>{data}</h3>
                                </div>
                            </React.Fragment>
                        ))}
                </div>
            </div>
        </div>
    );
};

export default Outcomes;
